module.exports = __webpack_public_path__ + "img/BY.b4234c83.svg";